import { Accordion } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { trackFaq } from '../Faq/events'
import SharedFaqItem from './SharedFaqItem'

interface SharedFaqProps {
  trackProps: { eventType: string; pageSource: string }
  brandedTitle?: boolean
  questions: { question: string; answer: string }[]
  /** Overrides the shared heading, which other pages also render. */
  title?: string
}

const SharedFaq = ({
  trackProps,
  brandedTitle = true,
  questions,
  title,
}: SharedFaqProps) => {
  const { t } = useTranslation('@mc/next')

  const trackFaqClick = (expandedIds: Array<string | number>) => {
    if (expandedIds.length > 0) {
      trackFaq({
        question: expandedIds[0].toString(),
        ...trackProps,
      })
    }
  }

  return (
    <section data-testid='enterprise-faq'>
      <div className='mc-my-10'>
        <h1
          className={`mc-text-d1 mc-mx-auto mc-mt-10 mc-mb-9 mc-text--center mc-text--uppercase ${
            brandedTitle ? 'mc-text--brand' : ''
          }`}
        >
          {title ?? t('faq.title.shortForm')}
        </h1>
        <div className='row no-gutters justify-content-center'>
          <div className='col-12 col-md-8'>
            <Accordion onChange={trackFaqClick}>
              <SharedFaqItem
                question={questions[0].question}
                answer={questions[0].answer}
              />
              <SharedFaqItem
                question={questions[1].question}
                answer={questions[1].answer}
              />
              <SharedFaqItem
                question={questions[2].question}
                answer={questions[2].answer}
              />
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SharedFaq
